import { useRef, useCallback } from 'react';

interface UseLongPressOptions {
  onLongPress: () => void;
  delay?: number;
  onPress?: () => void;
}

export function useLongPress({ onLongPress, delay = 500, onPress }: UseLongPressOptions) {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const isLongPressRef = useRef(false);

  const start = useCallback(() => {
    isLongPressRef.current = false;
    
    timerRef.current = setTimeout(() => {
      isLongPressRef.current = true;
      onLongPress();
    }, delay);
  }, [onLongPress, delay]);

  const cancel = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  }, []);

  const handleEnd = useCallback(() => {
    cancel();
    if (!isLongPressRef.current && onPress) {
      onPress();
    }
  }, [cancel, onPress]);

  return {
    onTouchStart: start,
    onTouchEnd: handleEnd,
    onTouchMove: cancel,
    onMouseDown: start,
    onMouseUp: handleEnd,
    onMouseLeave: cancel,
    onContextMenu: (e: React.MouseEvent) => e.preventDefault(),
  };
}
